(function () {
  if (window.hhHomeProductsLoaded) return;
  window.hhHomeProductsLoaded = true;
  var states = new WeakMap();
  var MAX_PAGES = 50;
  var CARD = 'article.product[data-product-id]';
  function getButton(container) {
    return container.querySelector('.hh-home-more-button');
  }
  function cardsOf(grid) {
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.matches(CARD);
    });
  }
  function columns(grid) {
    var value = '';
    try {
      value = window.getComputedStyle(grid).gridTemplateColumns || '';
    } catch (e) {}
    value = value.replace(/\[[^\]]*\]/g, ' ').trim();
    if (!value || value === 'none') return 2;
    var count = value.split(/\s+/).filter(Boolean).length;
    return count > 0 ? count : 2;
  }
  function stepFor(cols) {
    return cols === 2 ? 6 : cols;
  }
  function hiddenCards(grid) {
    return cardsOf(grid).filter(function (card) { return card.hidden; });
  }
  function report(state, count) {
    var label = state.loadedLabel;
    state.status.textContent = label ? label.split('__COUNT__').join(String(count)) : String(count);
  }
  function setBusy(container, state, on) {
    var button = getButton(container);
    if (on) {
      state.grid.setAttribute('aria-busy', 'true');
      state.status.textContent = '';
      if (button) {
        button.disabled = true;
        button.textContent = button.dataset.loadingLabel || state.label;
      }
    } else {
      state.grid.removeAttribute('aria-busy');
      if (button) {
        button.textContent = state.label;
        button.disabled = false;
      }
    }
  }
  async function fetchPage(container, state) {
    var button = getButton(container);
    var nextUrl = button && button.dataset.nextUrl;
    if (!nextUrl) {
      state.done = true;
      return;
    }
    var sectionId = button.dataset.sectionId;
    var url = new URL(nextUrl, location.href);
    if (url.origin !== location.origin) throw new Error('cross-origin');
    var preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.searchParams.set('section_id', sectionId);
    var response = await fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('status ' + response.status);
    var markup = await response.text();
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    var incoming = Array.prototype.find.call(doc.querySelectorAll('[data-hh-home-products]'), function (el) {
      return el.getAttribute('data-section-id') === sectionId;
    });
    if (!incoming) throw new Error('section missing');
    var incomingButton = incoming.querySelector('.hh-home-more-button');
    var upcoming = incomingButton && incomingButton.dataset.nextUrl;
    if (upcoming && new URL(upcoming, location.href).href === new URL(nextUrl, location.href).href) {
      throw new Error('pagination loop');
    }
    var seen = new Set();
    cardsOf(state.grid).forEach(function (card) {
      seen.add(card.getAttribute('data-product-id'));
    });
    var fresh = [];
    Array.prototype.forEach.call(incoming.querySelectorAll('[data-hh-home-grid] > ' + CARD), function (card) {
      var id = card.getAttribute('data-product-id');
      if (!id || seen.has(id)) return;
      seen.add(id);
      fresh.push(card);
    });
    fresh.forEach(function (card) {
      var node = document.importNode(card, true);
      node.hidden = true;
      state.grid.appendChild(node);
    });
    if (upcoming) {
      button.dataset.nextUrl = upcoming;
    } else {
      state.done = true;
    }
  }
  async function fill(container, state, enough) {
    if (state.done || enough()) return;
    setBusy(container, state, true);
    try {
      var pages = 0;
      while (!state.done && !enough()) {
        pages += 1;
        if (pages > MAX_PAGES) throw new Error('too many pages');
        await fetchPage(container, state);
      }
    } finally {
      setBusy(container, state, false);
    }
  }
  function layout(state, step, mode) {
    var cards = cardsOf(state.grid);
    var total = cards.length;
    var target;
    if (state.done) {
      target = total;
    } else if (mode === 'init') {
      target = Math.min(step, total);
    } else {
      target = Math.floor(total / step) * step;
      if (!target) target = total;
    }
    cards.forEach(function (card, index) {
      card.hidden = index >= target;
    });
  }
  async function run(container, mode) {
    var state = states.get(container);
    if (!state) return;
    if (state.busy) {
      if (mode !== 'click') state.pending = true;
      return;
    }
    state.busy = true;
    var grid = state.grid;
    var cols = columns(grid);
    var step = stepFor(cols);
    var failed = false;
    var focusTarget = null;
    try {
      if (mode === 'click') {
        try {
          await fill(container, state, function () { return hiddenCards(grid).length >= step; });
        } catch (error) {
          failed = true;
        }
        if (failed) {
          state.status.textContent = state.errorLabel;
        } else {
          var batch = hiddenCards(grid).slice(0, step);
          batch.forEach(function (card) { card.hidden = false; });
          if (batch.length) {
            report(state, batch.length);
            focusTarget = batch[0].querySelector('a');
          }
        }
      } else {
        try {
          await fill(container, state, function () { return cardsOf(grid).length >= step; });
        } catch (error) {
          failed = true;
        }
        layout(state, step, mode);
        state.lastCols = cols;
        if (failed) {
          state.status.textContent = state.errorLabel;
        } else if (mode === 'resize') {
          state.status.textContent = '';
        }
      }
      var button = getButton(container);
      if (button && state.done && !hiddenCards(grid).length) button.remove();
      if (focusTarget) {
        focusTarget.focus({ preventScroll: true });
      } else if (failed && mode === 'click' && button && button.isConnected) {
        button.focus({ preventScroll: true });
      }
    } finally {
      state.busy = false;
      if (state.pending) {
        state.pending = false;
        if (columns(grid) !== state.lastCols) run(container, 'resize');
      }
    }
  }
  function setup(container) {
    if (states.has(container)) return states.get(container);
    var grid = container.querySelector('[data-hh-home-grid]');
    var status = container.querySelector('.hh-home-more-status');
    if (!grid || !status) return null;
    var button = getButton(container);
    var state = {
      grid: grid,
      status: status,
      label: button ? button.textContent : '',
      loadedLabel: button ? button.dataset.loadedLabel || '' : '',
      errorLabel: button ? button.dataset.errorLabel || '' : '',
      done: !button || !button.dataset.nextUrl,
      busy: false,
      pending: false,
      lastCols: 0
    };
    states.set(container, state);
    run(container, 'init');
    return state;
  }
  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hh-home-products]'), setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-hh-home-products]'), function (container) {
        var state = states.get(container);
        if (!state) return;
        if (state.busy) {
          state.pending = true;
          return;
        }
        if (columns(state.grid) !== state.lastCols) run(container, 'resize');
      });
    }, 150);
  });
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('.hh-home-more-button');
    if (!button || button.disabled) return;
    var container = button.closest('[data-hh-home-products]');
    if (!container) return;
    event.preventDefault();
    var state = states.get(container);
    if (!state) {
      state = setup(container);
      if (!state) return;
    }
    if (state.busy) return;
    run(container, 'click');
  });
})();